import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import types from 'prop-types';
import { branch, compose, withHandlers, lifecycle, mapProps, setDisplayName } from 'recompose';
import { noop } from 'lodash';
var initialized = compose(setDisplayName('behaviour(SetRef)'), withHandlers(function () {
  var node;
  return {
    setRef: function setRef(_ref) {
      var _ref$setRef = _ref.setRef,
          _setRef = _ref$setRef === void 0 ? noop : _ref$setRef;

      return function (ref) {
        node = node || ref;

        _setRef(node);
      };
    },
    getRef: function getRef() {
      return function () {
        return node;
      };
    }
  };
}), setDisplayName('behaviour(Initialized)'), lifecycle({
  componentDidMount: function componentDidMount() {
    var _this$props = this.props,
        getRef = _this$props.getRef,
        autoFocus = _this$props.autoFocus,
        rehydrate = _this$props.rehydrate,
        _this$props$onChange = _this$props.onChange,
        onChange = _this$props$onChange === void 0 ? noop : _this$props$onChange;
    var node = getRef();
    if (!node) return;
    autoFocus && node.focus();
    rehydrate && onChange({
      target: {
        value: node.value
      }
    });
  }
}), mapProps(function (_ref2) {
  var getRef = _ref2.getRef,
      autoFocus = _ref2.autoFocus,
      rehydrate = _ref2.rehydrate,
      props = _objectWithoutProperties(_ref2, ["getRef", "autoFocus", "rehydrate"]);

  return props;
}));
export default compose(branch(function (_ref3) {
  var autoFocus = _ref3.autoFocus,
      rehydrate = _ref3.rehydrate;
  return autoFocus || rehydrate;
}, initialized));
export var propTypes = {
  autoFocus: types.bool,
  rehydrate: types.bool
};